import { BuildingImportDtmRes } from '@gateway.Building'
import { yamadumiApi } from '../yamadumi-api'

export class ImportDtmGateway {
  /**
   * 取込日時取得 API
   */
  static getImportDtm = async (batchId: string) => {
    const params = {
      batchId
    }
    return await yamadumiApi.get<BuildingImportDtmRes>(
      '/api/building/import-dtm',
      params
    )
  }
}
